import * as React from 'react';
import type { RouteObject } from 'react-router-dom';

import { paths } from '@/paths';
import { Layout as DashboardLayout } from '@/layouts/v2/layout';
import { ReservationsPage } from '@/pages/v2/reservations';

export const route: RouteObject = {
  path: paths.reservations.index,
  element: (
    <DashboardLayout>
      <ReservationsPage />
    </DashboardLayout>
  ),
};





